import { render } from "./PagarComissaoModal.vue?vue&type=template&id=7400a7bd"
import script from "./PagarComissaoModal.vue?vue&type=script&lang=js"
export * from "./PagarComissaoModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__